import React from "react";
import { useSelector } from "react-redux";
import { filterBySearch } from "utils/utils";
import FoodCourtListSkeleton from "./skeleton/FoodCourtListSkeleton.js";
import ScrollContent from "components/UI/ScrollContent";
import FoodCourtItem from "components/FoodCourt/FoodCourtItem";
import languages from "languages/languages";

function FoodCourtLists(props) {
  const { list, loading } = props;
  const searchState = useSelector((state) => state.filter.filterByName);
  const langState = useSelector((state) => state.language.lang);
  const noResultText = languages[langState]["Không có kết quả phù hợp"];
  let filterShop = list;

  if (!list || loading) {
    return <FoodCourtListSkeleton />;
  }

  if (searchState) {
    filterShop = filterBySearch(filterShop, "title", searchState);
  }

  return (
    <ScrollContent mr={20}>
      {filterShop.length ? (
        filterShop.map((listItem, index) => {
          return <FoodCourtItem listItem={listItem} key={index}/>;
        })
      ) : (
        <p className="font-weight-bold ml-2">{noResultText}</p>
      )}
    </ScrollContent>
  );
}
export default FoodCourtLists;
